<template id="cartProduct">
  <tbody v-if="details.pdetails != null" class="nobordertop">
    <tr :style="details.pos?(details.pos%2==0?'background:#494949':'background:#333333'):''">
      <td scope="row" class="text-center"><div class="productid"> #{{details.pdetails.product_id}} </div></td>
      <td class="text-center"><div v-if="details.img_tag2 != null && details.img_tag2 != ''" class="productimage"><img :src="details.img_tag2" alt="image"></div></td>
      <td class="text-center"><div class="productname" v-html="details.pdetails.product_name"></div>
        <div v-if="details.pdetails.product_code != null" class="productbar"> <img src="@/images/barcode.png" alt="image"> <span class="eanname"> EAN </span> <span class="procode"> {{details.pdetails.product_code}} </span> </div>
      </td>
      <td class="text-center">
        <div v-if="readonly" class="order">{{oqty}}</div>
        <div v-else class="order">
          <div class="mobilepurchase purchasevalue">
            <div class="input-group">
              <span class="input-group-btn">
                <button v-on:click="addQty(-1)" type="button" class="btn btn-default btn-number" :disabled="oqty<=1" data-type="minus" data-field="quant[1]">
                  <span class="glyphicon glyphicon-minus"></span>
                </button>
              </span>
              <input type="text" name="quant[1]" :oos="oos" :class="((oos||nostock)?'nostock ':'')+'form-control input-number'" v-model="oqty" min="1" v-on:keyup.enter="addQty()" v-on:blur="addQty()"/>
              <span class="input-group-btn">
                <button v-on:click="addQty(1)" type="button" class="btn btn-default btn-number" data-type="plus" data-field="quant[1]">
                  <span class="glyphicon glyphicon-plus"></span>
                </button>
              </span>
            </div>
            <a v-on:click="remove($event)"><img style="max-width:none" src="@/images/crossimage.png" alt="image" /></a>
          </div>
        </div>
        <div class="getfree_wrapper" v-if="unitdiscount">
          <div class="getfree_tag blue" v-on:click="!readonly && addQty(parseInt(details.wbuym))">
            <div class="label_buy">{{res.buyfree}}</div>
            <div class="txt_buy">{{details.wbuym}}</div>
            <div class="label_free" v-html="res.getfree"></div>
            <div class="txt_free">{{details.wfreen}}</div>
            <div class="box_bg"></div>
          </div>
        </div>
        <!--div class="order"> {{oqty}} </div>
        <img class="getthumb" src="@/images/getthumb.png" alt="image"-->
      </td>
      <td class="text-center"><div class="qty"> {{details.fqty!=null?details.fqty:qty}} </div></td>
      <td class="text-center"><div class="unitcost"><span class="hkd"> {{curr}} </span><br>
          <!--span class="cost"> {{unitprice | format(fmt)}} </span></div></td-->
          <span class="cost"> {{details.wprice | format(fmt)}} </span></div></td>
      <td class="text-center">
        <!--div class="discount" v-if="!discounts || discounts.length==0">-</div-->
        <!--div class="discount" v-for="(discount, didx) in discounts" v-if="discount.prefix == null || discount.prefix != 'FG'"-->
        <div class="discount" v-if="!dis_shown || dis_shown.length==0">--</div>
        <div class="discount" v-for="(discount, didx) in dis_shown" v-if="discount.prefix == null || discount.prefix != 'FG'">
          <p v-if="discount.calamt == null"> {{res.fgdesc}}</p>
          <p v-else> {{discount.name}} </p>
          <h3 v-if="discount.dprice > 0"> +{{(discount.calamt * 100)|format('0.0')}} % </h3>
          <h3 v-else-if="discount.prefix == 'TD'"> {{(discount.calamt * -1 * 100)|format('0.0')}} % </h3>
          <h3 v-else-if="discount.prefix == 'SP'"> {{(discount.calamt * -1 * 100)|format('0.0')}} % </h3>
          <h3 v-else-if="discount.prefix == 'CD'"> {{(discount.calamt * -1 * 100)|format('0.0')}} % </h3>
          <h3 v-else-if="discount.ctype == 'PT'"> {{(discount.calamt * -1 * 100)|format('0.0')}} % </h3>
          <h3 v-else-if="discount.ctype != null && discount.ctype.indexOf('FP@') >= 0"> #{{discount.products[0].product_id}}</h3>
          <h3 v-else-if="discount.calamt == null"> {{res.fg}} </h3>
          <h3 v-else> {{(-1*discount.dprice) | format(fmt)}} </h3>
          <!--h3 :d="discount.dprice" :c="discount.calamt" v-else> {{discount.calamt * -1}} </h3-->
          <span v-if="discount.dprice > 0"> +{{(discount.dprice) | format(fmt+1)}} </span>
          <span v-else-if="discount.prefix == 'TD'"> ({{(-1*discount.dprice) | format(fmt+1)}}) </span>
          <span v-else-if="discount.prefix == 'SP'"> ({{(-1*discount.dprice) | format(fmt+1)}}) </span>
          <span v-else-if="discount.ctype != null && discount.ctype.indexOf('FP@') >= 0"> +{{(discount.products[0].qty)}} </span>
          <span v-else> ({{(-1*discount.dprice) | format(fmt+1)}}) </span>
        </div>
<!--
        <div class="discount" v-if="unitdiscount">
          <p> Sagami Advertising Support: </p>
          <h3> 2% </h3>
          <span> (3.18) </span>
        </div>
-->
      </td>
      <td class="text-center"><div :s="JSON.stringify(details)" class="subtotal"> {{curr}} <br>
          <span s="a" v-if="details.sub_total != null" class="subTotal1"> {{details.sub_total | format(fmt)}} </span>
          <span s="b" v-else-if="details.subtotal != null" class="subTotal1"> {{details.subtotal | format(fmt)}} </span>
          <span s="c" v-else-if="total != null" class="subTotal1"> {{total | format(fmt)}} </span>
          <span s="d" v-else class="subTotal1"> {{subtotal | format(fmt)}} </span>
      </div></td>
    </tr>
    <tr v-if="casediscount" :style="details.pos?(details.pos%2==1?'background:#494949':'background:#333333'):''">
      <td scope="row" class="text-center"><div class="productid"> </div></td>
      <td scope="row" class="text-center"><div class="productid"> </div></td>
      <td scope="row" class="text-center"><div class="productname"> </div></td>
      <td scope="row" class="text-center"><div class="order casediscount"> Case Discount </div></td>
      <td scope="row" class="text-center"><div class="qty casediscount"> x2 </div></td>
      <td scope="row" class="text-center"><div class="unitcost casediscount"> - {{curr}} 123.0 </div></td>
      <td scope="row" class="text-center"><div class="discount"> </div></td>
      <td scope="row" class="text-center"><div class="subtotal casediscount"> - {{curr}} 246.0</div></td>
    </tr>
  </tbody>
</template>

<script>

import utils from './Utils.vue'
import orderProduct from './OrderProduct.vue'

export default {
  extends: orderProduct,
  name: 'cartProduct',
  props:['readonly', 'ocurr'],
  created:function() {
    var self = this;
    this.curr = utils.getCurrencySym();
    if (this.ocurr) {
        this.curr = this.ocurr
    }
    this.oqty = this.details.oqty;
    this.$root.$on('nostock.'+this.details.pdetails.product_id, data => {
      this.oos = data;
      this.$forceUpdate();
    });
  },
  mounted:function() {
    //console.log("cp", this.qty);
  },
  computed:{
    dis_shown:function() {
      var dis = [];
      //if (parseInt(this.details.wbuym) != 0 && parseInt(this.details.wprice) != parseInt(this.unitprice)) {
      //if (parseInt(this.details.wbuym) != 0) {
      if (parseInt(this.details.wfreen) > 0) {
        //dis.push({"dprice":(this.details.wprice - this.unitprice)*this.qty});
        dis.push({"dprice":(this.unitprice - this.details.wprice).toFixed(4)*this.qty});
      }
      if (this.discounts != null) {
        for (var i=0;i<this.discounts.length;i++) {
          if (this.discounts[i].prefix == 'FG') {
            var tmp = JSON.parse(JSON.stringify(this.discounts[i]));
            delete tmp.prefix;
            dis.splice(0, 1, tmp);
          }
          dis.push(JSON.parse(JSON.stringify(this.discounts[i])));
        }
      }
      console.log('discount shown', dis, this.details, this.discounts);
      //console.log('discount', dis, this.unitdiscount, this.details.wbuym, this.details.wfreen);
      return dis;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CartProduct.vue